import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'cm-release-modal',
  templateUrl: './release-modal.component.html',
  styleUrls: ['./release-modal.component.scss'],
})
export class ReleaseModalComponent implements OnInit {
  releaseInfo;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    this.releaseInfo = this.data.messages;
  }
}
